import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatBadge } from "@/components/admin/AdminLayout";

export default function Clients() {
  const [clients, setClients] = useState([]);
  useEffect(() => { api.get("/admin/clients").then((r) => setClients(r.data)); }, []);
  return (
    <div className="p-10 max-w-[1400px]">
      <PageHeader eyebrow="CRM" title="Clients" description="Every client on the DiTours platform — with cashback and referral tracking." />
      <div className="border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 label-caps text-left">
              <th className="p-4">Name</th>
              <th className="p-4">Email</th>
              <th className="p-4">Phone</th>
              <th className="p-4">Referral code</th>
              <th className="p-4 text-right">Cashback</th>
              <th className="p-4">Newsletter</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 && <tr><td colSpan={7} className="p-16 text-center text-slate-500">No clients yet.</td></tr>}
            {clients.map((c) => (
              <tr key={c.id} className="border-b border-slate-200 hover:bg-slate-50">
                <td className="p-4 text-[#0a0f1e]">{c.first_name} {c.last_name}</td>
                <td className="p-4 text-slate-700 text-xs">{c.email}</td>
                <td className="p-4 text-slate-500 text-xs font-mono">{c.phone}</td>
                <td className="p-4"><span className="text-[#f59e0b] font-mono text-xs">{c.referral_code}</span></td>
                <td className="p-4 text-right text-[#0a0f1e] font-mono">€{(c.cashback_balance || 0).toFixed(2)}</td>
                <td className="p-4 text-xs text-slate-500">{c.newsletter_subscribed ? "Yes" : "No"}</td>
                <td className="p-4"><StatBadge status={c.blocked ? "suspended" : "active"} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
